import { forwardRef } from "react";
import cn from "classnames";

const SelectField: React.FC<any> = forwardRef<any, any>(({ label, error, withAsterisk, data, ...selectProps }, ref) => {
	return (
		<fieldset className="w-full">
			{label && (
				<label className="block text-sm text-slate-300 mb-1.5">
					{label}
					{withAsterisk && "*"}
				</label>
			)}
			<select
				defaultValue=""
				className={cn(
					"w-full px-4 py-3 bg-surface border border-white/10 rounded-lg text-slate-200 focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent transition-colors appearance-none",
					{ "border-red-500 focus:border-red-500 focus:ring-red-500": error }
				)}
				{...selectProps}
				ref={ref}
			>
				<option disabled value="">
					Välj
				</option>
				{data.map((field, i) => (
					<option key={JSON.stringify(field)} value={field.value}>
						{field.label}
					</option>
				))}
			</select>
			{error && <label className="text-red-400 text-sm mt-1">{error.message}</label>}
		</fieldset>
	);
});

SelectField.displayName = "SelectField";
export default SelectField;
